import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Button, Tooltip } from 'reactstrap'
import styles from './TextColorsSlatePlugin.scss'
import { COLORS, hasTextColor, hasTextColors, onClickButton } from './TextColorsSlatePluginContainer'

class TextColorsButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
    this.onClicks = {}
    for (let color in COLORS) {
      this.onClicks[color] = this.onColor.bind(this, color)
    }
  }

  onColor (color, e) {
    return this.props.onChange(onClickButton(e, this.props.state, color))
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, style } = this.props
    const isActive = hasTextColors(editorState)

    const customStyle = {}

    return (
      <Button
        id={'TextColorsButton' + this.uid}
        style={{...style, ...customStyle}}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.TextColorsButton}
      >
        <span style={{color: COLORS.Green}}>Co</span>
        <span style={{color: COLORS.Orange}}>lo</span>
        <span style={{color: COLORS.Pink}}>rs</span>
        {
          process.env.NODE_ENV !== 'test' &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen}
            autohide={false}
            target={'TextColorsButton' + this.uid} toggle={this.toggle}>
            <ButtonGroup vertical style={{margin: '8px'}}>
              {Object.keys(COLORS).map(key =>
                <Button key={key}
                  style={{color: COLORS[key]}}
                  color={hasTextColor(editorState, key) ? 'primary' : 'secondary'}
                  onClick={this.onClicks[key]}>{key}
                </Button>
              )}
            </ButtonGroup>
          </Tooltip>
        }
      </Button>
    )
  }
}

TextColorsButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object
}

export default TextColorsButton



// WEBPACK FOOTER //
// ./src/components/TextColorsSlatePlugin/TextColorsButton.js